export default __webpack_public_path__ + "static/media/drop-down.b6dcad98.svg";